import { call, put } from 'redux-saga/effects';
import { CreateOfferAsyncActions } from 'store/actions/createOffer';
import { apiCall } from 'utils/apiCall';
import { toast } from 'react-toastify';

function* create(action) {
  const {
    CreateOffer: {
      Actions: { SUCCESS, FAILURE },
    },
  } = CreateOfferAsyncActions;
  const {
    payload: { offer },
  } = action;

  try {
    const response = yield call(apiCall, '/offers', 'post', offer);
    yield put(SUCCESS(response.data));
  } catch (error) {
    toast.error(error.message);
    yield put(FAILURE(error));
  }
}

export default create;
